import classnames from 'classnames';
import { MainContext } from 'context/context';
import { ethInstance } from 'evm-chain-scripts';
import PropTypes from 'prop-types';
import { Fragment, memo, useContext, useEffect, useState } from 'react';
import Alert from 'react-bootstrap/Alert';
import './NetworkChecker.scss';

function NetworkChecker({ className, supportedChains = [] }) {
  const [show, setShow] = useState(false);
  const { setCurrentNetwork, currentNetwork } = useContext(MainContext);

  const checkNetwork = async () => {
    try {
      const chainId = await ethInstance.getChainId();
      const isOk = supportedChains.indexOf(chainId) > -1;

      if (isOk) {
        console.warn(`NetworkChecker: detected connection to ${chainId}`);
      } else {
        console.warn(
          `NetworkChecker: wrong network. Expected one of ${supportedChains}, detected ${chainId}`
        );
      }

      setShow(!isOk);
    } catch (err) {
      console.error(err);
      setShow(true);
    }
  };

  useEffect(() => {
    checkNetwork();
  }, [currentNetwork]);

  useEffect(() => {
    ethInstance.onChainChanged(setCurrentNetwork);
    //metamask
    window.ethereum?.on('chainChanged', (chainId) => {
      setCurrentNetwork(parseInt(chainId));
    });
  }, []);

  if (show) {
    return (
      <Alert
        className={classnames('network-checker', className)}
        variant="warning"
        dismissible
        onClose={() => setShow(false)}>
        Oops, looks like we cannot connect to the blockchain. Your current network is{' '}
        {currentNetwork || 'unknown'}. Supported networks include [{supportedChains.toString()}]
        <br />
        Check which network your ethereum wallet is connected to.
      </Alert>
    );
  }

  return <Fragment />;
}

NetworkChecker.propTypes = {
  className: PropTypes.string
};

export default memo(NetworkChecker);
